import { createEmitter } from "../Utilities/events";
import { MediaType, detectMediaType, canPlayNativeHls } from "../Core/MediaTypes";
import { StreamingProviderEvents } from "./StreamingProvider";

/**
 * Progressive MP4 / WebM / Ogg via native <video>.
 */
export function createProgressiveProvider() {
  var emitter = createEmitter();
  var video = null;
  var name = "progressive";

  return {
    getName: function () {
      return name;
    },
    getSurfaceKind: function () {
      return "video";
    },
    initialize: function () {
      return Promise.resolve();
    },
    supports: function (source) {
      if (!source || !source.src) {
        return false;
      }
      var type = source.type || detectMediaType(source.src);
      return type === MediaType.MP4 || type === MediaType.UNKNOWN;
    },
    attach: function (el) {
      video = el;
    },
    detach: function () {
      video = null;
    },
    load: function (source, options) {
      if (!video) {
        return Promise.reject(new Error("progressive: video not attached"));
      }
      options = options || {};
      if (source.poster) {
        video.poster = source.poster;
      }
      if (options.muted != null) {
        video.muted = !!options.muted;
        video.defaultMuted = !!options.muted;
      }
      video.setAttribute("playsinline", "true");
      video.src = source.src;
      video.load();
      return waitForCanPlay(video);
    },
    getLevels: function () {
      return [];
    },
    setLevel: function () {},
    getCurrentLevel: function () {
      return -1;
    },
    on: emitter.on,
    off: emitter.off,
    destroy: function () {
      if (video) {
        video.removeAttribute("src");
        try {
          video.load();
        } catch (e) {
          /* ignore */
        }
      }
      video = null;
      emitter.emit(StreamingProviderEvents.DESTROYED);
      emitter.removeAllListeners();
    },
  };
}

function waitForCanPlay(video) {
  return new Promise(function (resolve, reject) {
    var settled = false;
    var onOk = function () {
      if (settled) return;
      settled = true;
      cleanup();
      resolve();
    };
    var onFail = function () {
      if (settled) return;
      settled = true;
      cleanup();
      var mediaError = video.error;
      reject({
        code: mediaError ? mediaError.code : 0,
        message: (mediaError && mediaError.message) || "progressive load failed",
      });
    };
    var cleanup = function () {
      video.removeEventListener("canplay", onOk);
      video.removeEventListener("error", onFail);
    };
    video.addEventListener("canplay", onOk);
    video.addEventListener("error", onFail);
  });
}

export default createProgressiveProvider;
